<div class="qa-ai-overlay" *ngIf="visible">
  <div class="card mb-3">
    <div class="card-header qa-ai-header">
      <i class="fa fa-magic"></i> {{_(KEYS.EDITOR.AI_ASSISTANT)}}
      <div class="qa-ai-header-actions float-right">
        <button class="btn btn-sm btn-outline-secondary qa-ai-new-session" (click)="onNewSession()" *ngIf="messages.length">
          <i class="fa fa-refresh"></i> {{_(KEYS.EDITOR.AI_NEW_SESSION)}}
        </button>
        <button class="close" (click)="hide()">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </div>

    <div class="card-body qa-ai-messages" #messageList>
      <div class="qa-ai-intro text-muted" *ngIf="!messages.length">
        <i class="fa fa-magic"></i>
        {{_(KEYS.EDITOR.AI_INTRO)}}
      </div>

      <ng-container *ngFor="let message of messages">
        <div class="qa-ai-row user" *ngIf="message.role === 'user'">
          <div class="qa-ai-bubble user">{{message.text}}</div>
        </div>

        <div class="qa-ai-row assistant" *ngIf="message.role === 'assistant' && message.kind === 'text'">
          <div class="qa-ai-bubble assistant qa-ai-markdown" [innerHTML]="message.text | markdown"></div>
        </div>

        <div class="qa-ai-row assistant" *ngIf="message.role === 'assistant' && message.kind === 'plan'">
          <div class="qa-ai-plan card">
            <div class="card-header">
              <i class="fa fa-list-ol"></i> {{_(KEYS.EDITOR.AI_PROPOSED_PLAN)}}
            </div>
            <div class="card-body qa-ai-markdown" [innerHTML]="message.text | markdown"></div>
          </div>
        </div>

        <div class="qa-ai-row assistant" *ngIf="message.role === 'assistant' && message.kind === 'result'">
          <div class="qa-ai-result alert alert-success">
            <i class="fa fa-check-circle"></i>
            {{message.text || _(KEYS.EDITOR.AI_RESULT_READY)}}
          </div>
        </div>

        <div class="qa-ai-row system" *ngIf="message.role === 'system'">
          <div class="qa-ai-error alert alert-danger">
            <i class="fa fa-exclamation-triangle"></i> {{message.text}}
          </div>
        </div>
      </ng-container>

      <div class="qa-ai-row assistant" *ngIf="isThinking">
        <div class="qa-ai-thinking text-muted">
          <i class="fa fa-spinner fa-spin"></i>
          {{getActivityLabel()}}
        </div>
      </div>

      <div class="qa-ai-row system" *ngIf="errorMessage">
        <div class="qa-ai-error alert alert-danger">
          <i class="fa fa-exclamation-triangle"></i> {{errorMessage}}
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="qa-ai-actions mb-2" *ngIf="isAwaitingConfirmation || result">
        <button class="btn qa-ai-btn-brand mr-1" *ngIf="isAwaitingConfirmation" (click)="onConfirmPlan()">
          <i class="fa fa-check"></i> {{_(KEYS.EDITOR.AI_CONFIRM_PLAN)}}
        </button>
        <button class="btn qa-ai-btn-brand" *ngIf="result" (click)="onApply()">
          <i class="fa fa-download"></i> {{_(KEYS.EDITOR.AI_APPLY)}}
        </button>
      </div>

      <div class="qa-ai-attachments" *ngIf="attachments.length">
        <span class="qa-ai-attachment badge badge-light" *ngFor="let attachment of attachments; let i = index">
          <i class="fa fa-paperclip"></i>
          {{attachment.name}} ({{formatFileSize(attachment.sizeBytes)}})
          <button class="qa-ai-attachment-remove" (click)="removeAttachment(i)" [disabled]="isThinking">
            <i class="fa fa-close"></i>
          </button>
        </span>
      </div>

      <div class="qa-ai-input">
        <input
          type="file"
          #fileInput
          class="qa-ai-file-input"
          accept="application/pdf,image/png,image/jpeg,image/webp"
          multiple
          (change)="onFilesSelected($event)"
        />
        <button class="btn btn-outline-secondary qa-ai-attach" (click)="onAttachClick()"
                [disabled]="isThinking" title="{{_(KEYS.EDITOR.AI_ATTACH)}}">
          <i class="fa fa-paperclip"></i>
        </button>
        <textarea
          class="form-control"
          rows="2"
          placeholder="{{_(KEYS.EDITOR.AI_PLACEHOLDER)}}"
          [(ngModel)]="promptText"
          (keydown)="onPromptKeydown($event)"
          [disabled]="isThinking"
        ></textarea>
        <button class="btn qa-ai-btn-brand" (click)="onSend()"
                [disabled]="isThinking || (!promptText.trim() && !attachments.length)">
          <i class="fa fa-paper-plane"></i> {{_(KEYS.EDITOR.AI_SEND)}}
        </button>
      </div>
    </div>

    <div class="qa-ai-stats text-muted">
      <span><i class="fa fa-clock-o"></i> {{formatDuration(activeMs)}}</span>
      <span class="qa-ai-stats-sep">&middot;</span>
      <span>{{formatTokens(usage ? usage.totalTokens : 0)}} Tokens</span>
      <span class="qa-ai-stats-sep">&middot;</span>
      <span>&asymp; {{formatCost(usage ? usage.estimatedCost : 0)}}</span>
    </div>
  </div>
</div>
